import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "/api",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("adminToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminUsername");
      if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

/**
 * Resolve a backend image path to a full URL.
 * /uploads/photo.jpg → http://localhost:5001/uploads/photo.jpg
 * /images/x.jpg (public folder) → /images/x.jpg (no change)
 */
export function imgUrl(src) {
  if (!src) return "";
  if (src.startsWith("http") || src.startsWith("/images")) return src;
  if (src.startsWith("/")) return `${BACKEND_URL}${src}`;
  return `${BACKEND_URL}/${src}`;
}

export default api;
